import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function Privacy() {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    return (
        <div style={{ padding: "2rem" }}>
            <Link to="/" className="safe-top-link">
    ← Home
</Link>

            <h1>Privacy Policy</h1>

            <p>
                Figure It Out is designed to collect as
                little personal information as possible.
                We only collect information that is
                necessary to provide the app's features,
                save your progress and improve the user
                experience.
            </p>

            <p>
                Some activities ask you to enter responses,
                reflections or questions. This information
                may be securely transmitted to trusted
                third-party AI services, including OpenAI,
                solely for the purpose of generating
                personalised feedback within the app.
            </p>

            <p>
                Please do not include sensitive personal
                information such as passwords, financial
                details, medical information or other
                confidential information in your responses.
            </p>

            <p>
                Figure It Out uses Google Firebase to
                provide services including authentication,
                secure data storage, cloud functions,
                analytics and application hosting.
            </p>

            <p>
                Anonymous or aggregated usage information
                may be collected to understand how the app
                is used, improve performance, diagnose
                technical issues and enhance the learning
                experience.
            </p>
            <p>
                If you create an account, your email
                address and learning progress are stored
                securely so that you can access your
                progress across devices.
            </p>
            <p>
                This privacy policy may be updated as
                Figure It Out continues to develop.
            </p>
            <h2>Contact</h2>

            <p>
                If you have any questions about this
                Privacy Policy, please contact us through
                the Contact page on the Figure It Out
                website.
            </p>
            <p>
                You may request deletion of your account
                and associated data at any time by
                contacting us through the Contact page.
            </p>
            <p>
                <strong>Effective:</strong> July 2026
            </p>
        </div>
    );
}